export default __webpack_public_path__ + "static/hotspots-fa58e45b4e6215acdcc95950c76765bd.mp4";